<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
input.mx-input {
  height: 40px !important;
}
</style>

<template>
  <v-container fluid>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        ใบกำกับภาษี / ใบเสร็จรับเงิน
      </div>
      <v-spacer></v-spacer>
      <v-btn color="success" elevation="0" dark @click="create_form()">
        <v-icon left>mdi-file-plus</v-icon>สร้างใบกำกับภาษี / ใบเสร็จรับเงิน
      </v-btn>
    </v-layout>
    <v-divider class="my-2"></v-divider>
    <SearchBar :Page="'Invoice'"></SearchBar>
    <v-layout
      v-resize="onResize"
      column
      class="pt-5 d-flex justify-space-between"
    >
      <v-data-table
        :headers="headers"
        :items="invoices"
        :items-per-page="20"
        class="elevation-1"
        :search="search"
        @click:row="handleRowClick"
      >
        <template v-slot:item.CREATED_AT="{ item }">{{
          item.CREATED_AT | formatDate
        }}</template>
        <template v-slot:item.ACTUAL_PAY="{ item }">{{
          item.ACTUAL_PAY | delimeter
        }}</template>
        <template v-slot:item.DOC_STATUS="{ item }">
          <span v-if="item.PAY_TYPE == 'NONQR'">
            <span
              class="mx-2"
              v-if="item.STATUS == 'REQUESTED' || item.STATUS == 'PAID'"
            >
              <v-icon color="blue darken-1" dark @click="view_slip(item)">
                mdi-file-document
              </v-icon>
            </span>
            <span v-else class="mx-5"></span>
            <DocStatus :TableData="item" :Page="'Invoice'"></DocStatus>
          </span>

          <span v-else>
            <span class="mr-n6" v-if="item.STATUS == 'PAID'">
              <v-icon color="blue darken-1"> mdi-qrcode </v-icon>
            </span>
            <span class="mx-5"></span>

            <DocStatus :TableData="item" :Page="'Invoice'"></DocStatus>
          </span>
        </template>
        <template v-slot:item.detail="{ item }">
          <TableMenu :TableData="item" :Page="'Invoice'"></TableMenu>
        </template>
      </v-data-table>
      <v-dialog v-model="dialog" max-width="500" :retain-focus="false">
        <v-card>
          <v-card-title class="text-h4 subtitle-1 font-weight-bold info--text">
            หลักฐานการโอนเงิน
          </v-card-title>

          <v-card-text>
            <v-divider></v-divider>
            <v-row justify="center">
              <v-col cols="12" lg="12">
                <v-card
                  style="text-align: -webkit-center"
                  @click.stop="selectedImage = null"
                  v-if="selectedImage"
                >
                  <v-img :src="imgUrl" width="100%" class="white"></v-img>
                </v-card>

                <v-card
                  style="text-align: -webkit-center"
                  @click="zoom()"
                  v-else
                >
                  <v-img
                    :src="imgUrl"
                    width="25%"
                    height="25%"
                    class="white"
                  ></v-img>
                </v-card>
              </v-col>
              <v-col cols="12" lg="12" class="mb-n9">
                วันเวลาที่โอน:
                <v-text-field
                  v-model="transferDateTime"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="mb-n9">
                โอนจากธนาคาร:
                <v-text-field v-model="fromBank" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="mb-n9">
                ไปยังธนาคาร:
                <v-text-field v-model="toBank" outlined dense></v-text-field>
              </v-col>
              <v-col cols="12" lg="6" class="mb-n9">
                เลขที่บัญชี:
                <v-text-field
                  v-model="account_number"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" lg="12" class="mb-n5">
                หมายเหตุ:
                <v-textarea
                  outlined
                  dense
                  rows="2"
                  v-model="remark"
                ></v-textarea>
              </v-col>

              <v-col
                cols="12"
                lg="6"
                v-if="
                  table_item.STATUS == 'REQUESTED' ||
                  table_item.STATUS == 'CANCELED'
                "
              >
                <v-btn
                  color="success"
                  width="100%"
                  @click="confirm(table_item)"
                >
                  ยืนยันการจ่ายเงิน
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                lg="6"
                v-if="
                  table_item.STATUS == 'REQUESTED' ||
                  table_item.STATUS == 'CANCELED'
                "
              >
                <v-btn
                  color="red"
                  dark
                  width="100%"
                  @click="cancel(table_item)"
                >
                  ยกเลิกการจ่ายเงิน
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <EmailModal
      ref="Invoice_Mail"
      :Page="'Invoice'"
    ></EmailModal>
  </v-container>
</template>

<script>
import TableMenu from '../components/TableMenu'
import SearchBar from '../components/SearchBar'
import EmailModal from '../components/EmailModal'
import DocStatus from "../components/DocStatus";
import XLSX from "xlsx";
import moment from 'moment'
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "invoice",
  components: {
    TableMenu,
    SearchBar,
    EmailModal,
    DocStatus
  },
  data: () => ({
    passData: Array,
    search: "",
    imgUrl: "",
    table_item: [],
    selectedImage: null,
    transferDateTime: "",
    fromBank: "",
    toBank: "",
    account_number: "",
    remark: "",
    dialog: false,
    headers: [
      {
        text: "วันที่",
        align: "start",
        sortable: false,
        value: "CREATED_AT",
      },
      { text: "เลขที่เอกสาร", value: "INVOICE_ID" },
      { text: "ชื่อลูกค้า/ชื่อโปรเจ็ค", value: "CUSTOMER_NAME" },
      { text: "รหัสอ้างอิง", value: "CT_REF" },
      { text: "ยอดรวมสุทธิ", value: "ACTUAL_PAY" },
      { text: "สถานะ", value: "DOC_STATUS", align: "center" },
      { text: "", value: "detail" },
    ],
    momentFormat: {
      // Date to String
      stringify: (date) => {
        return date
          ? moment(date).add(543, "year").locale("th").format("LL")
          : "";
      },
      // String to Date
      parse: (value) => {
        return value ? moment(value, "LL").toDate() : null;
      },
    },
    invoices: [],
  }),
  computed: {
    ...mapGetters({

    })
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },
  created() {
    this.$store.commit('Quotation/SET_IS_EDIT', false)
  },
  mounted() {

    this.list_invoices()
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x

    },
    formatDate(data) {
      return moment(data).format('DD-MM-YYYY')
    }
  },
  methods: {
    ...mapMutations({
      SET_STEP: 'Drawer/SET_STEP',
      LOADER: "Drawer/SET_LOADER",
      I_SET: "Invoice/SET_ELEMENT",
      I_EDIT: "Invoice/SET_IS_EDIT",
      I_SET_PRODUCT: "Invoice/SET_PRODUCT_LIST",
      I_SET_ALL: "Invoice/SET_ALL_ELEMENT",
      I_MERGE: "Invoice/MERGE_ALL_ELEMENT",
      I_SET: "Invoice/SET_ELEMENT",
      I_SPLITING: "Invoice/SET_SPLITING",
    }),
    ...mapActions({

    }),
    handleRowClick(item) {
      // this.$store.commit('Quotation/SET_IS_EDIT', true)
      // this.$store.commit("Quotation/SET_ELEMENT", {
      //   key: "QUOTATION_ID",
      //   value: item.qt_id,
      // });
      // this.SET_STEP(4)
      // this.$router.push({ path: '/form' })
    },
    list_invoices(time, text) {
      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      this.$token_api
        .post("/list-invoice", date_obj)
        .then((response) => {
          this.invoices = response.data.data;
          this.search = text
        })
        .catch((err) => { });
    },
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    create_form() {
      this.SET_STEP(4)
      this.$router.push({ path: "/form" });
    },
    async edit_invoice(tbl_data) {
      this.LOADER(true);
      this.I_EDIT(true)
      let response = await this.$token_api
        .post("/get-invoice-by-id", {
          INVOICE_ID: tbl_data.INVOICE_ID,
        })
        .catch((err) => {
          this.LOADER(false);
        });
      let data = response.data.data;
      this.I_SPLITING(false)
      if (data.length > 0) {
        const prod_detail = await new Response(data[0].PRODUCT_LIST).json();
        // console.log(data)
        if (data[0].SPLIT_OPTION != '' && data[0].SPLIT_OPTION) {
          // console.log('splitt')
          this.SET_STEP(4);
          this.I_SPLITING(true)
          this.I_SET({ key: "SPLIT_PAY", value: "1" });
          this.I_MERGE(data[0]);
          this.I_SET_PRODUCT(prod_detail);
          this.$router.push({ path: "/form" });
          this.LOADER(false);

        } else {
          this.SET_STEP(4);
          this.I_MERGE(data[0]);
          this.I_SET_PRODUCT(prod_detail);
          this.$router.push({ path: "/form" });
          this.LOADER(false);
        }
      } else {
        this.LOADER(false);
      }


    },
    send_email(tbl_data) {
      this.$refs.Invoice_Mail.openModal(tbl_data)
    },
    download_invoice(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-invoice/${tbl_data.INVOICE_ID}`).then((response) => {

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'ใบกำกับภาษี_' + tbl_data.INVOICE_ID + '.pdf');
        document.body.appendChild(link);
        link.click();
        this.LOADER(false)
      }).catch((err) => {
        this.$swal({
          title: "เกิดข้อผิดพลาด",
          icon: "warning",
          text: "ไม่พบเอกสารกรุณาเข้าไปบันทึกใหม่อีกครั้ง",
        })
        this.LOADER(false)
      });
    },
    print_invoice(tbl_data) {
      this.LOADER(true)
      this.$download_api.get(`/donwload-invoice/${tbl_data.INVOICE_ID}`).then((response) => {

        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(response.data, 'ใบกำกับภาษี_' + tbl_data.INVOICE_ID + '.pdf'); //IE is the worst!!!
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          printJS(url)
        }
        this.LOADER(false)
      }).catch((err) => {
        this.$swal({
          title: "เกิดข้อผิดพลาด",
          icon: "warning",
          text: "ไม่พบเอกสารกรุณาเข้าไปบันทึกใหม่อีกครั้ง",
        })
        this.LOADER(false)
      });
    },
    remove_invoice(tbl_data) {
      this.$swal({
        title: "ต้องการลบข้อมูลหรือไม่",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      })
        .then((result) => {
          if (result.value) {
            // console.log(tbl_data.qt_id);
            this.$token_api
              .delete("/delete-invoice", {
                data: {
                  INVOICE_ID: tbl_data.INVOICE_ID,
                }
              })
              .then((response) => {
                this.list_invoices()
              })
              .catch((err) => { });
          }
        });
    },
    export_invoice(time, text) {
      let date_obj = {
        SE_DATE1: typeof (time) == 'undefined' ? null : time[0],
        SE_DATE2: typeof (time) == 'undefined' ? null : time[1],
      }
      let xls_json = []
      this.$token_api
        .post("/list-invoice", date_obj)
        .then((response) => {
          response.data.data.forEach((element) => {
            xls_json.push({
              'วันที่เอกสาร': moment(element.CREATED_AT).format('DD-MM-YYYY'),
              'เลขที่เอกสาร': element.INVOICE_ID,
              'ชื่อลูกค้า/ชื่อโปรเจค': element.CUSTOMER_NAME,
              'ยอดรวมสุทธิ': element.ACTUAL_PAY
            });
          });
          const dataWS = XLSX.utils.json_to_sheet(xls_json);
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, dataWS);
          XLSX.writeFile(wb, "ข้อมูลใบกำกับภาษี.xlsx");
        })
        .catch((err) => {
          this.$swal({
            title: "เกิดช้อผิดพลาด",
            icon: "warning",
            text: `เกิดข้อผิดพลาดกรุณาลองใหม่อีกครั้ง\n${err}`,
            timer: 2000
          })
        });
    },
    view_slip(item) {
      this.LOADER(true)
      this.dialog = true
      this.table_item = item
      this.$download_api.get(`/download-slip/${item.SLIP_FILE_NAME}`).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        this.imgUrl = url
        this.transferDateTime = moment(item.DATE_PAID).locale("th").format("LLLL")
        this.fromBank = item.FROM_BANK
        this.toBank = item.BANK
        this.account_number = item.ACCOUNT_NUMBER
        this.remark = item.ADDITIONAL_INFO
        this.LOADER(false)
      }).catch((e) => {
        this.LOADER(false)
      });


    },
    zoom() {
      this.selectedImage = true;
    },
    confirm(item) {
      this.$swal({
        title: "ยืนยันการชำระเงิน",
        text: `กรุณากดปุ่ม "ยีนยัน" เพื่อยืนยันการชำระเงิน`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$token_api.post("/confirm-paid", {
            INVOICE_ID: item.INVOICE_ID,
            TRANSACTION_ID: item.TRANSACTION_ID,
            NEWCUSTOMER_ID: item.NEWCUSTOMER_ID,
            CUS_STATUS: item.CUS_STATUS
          })
            .then((response) => {
              this.$swal("ยืนยันการชำระเงินสำเร็จ", "สำเร็จ", "success");
              this.dialog = false
              this.list_invoices()

            })
            .catch((err) => {
              this.$swal("เกิดข้อผิดพลาด", "ลองใหม่อีกครั้ง", "error");
            });
        }
      });
    },
    cancel(item) {
      this.$swal({
        title: "ยกเลิกการชำระเงิน",
        text: `กรุณากดปุ่ม "ยีนยัน" เพื่อยกเลิกการชำระเงิน`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "ยืนยัน",
        cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.value) {
          this.$token_api.post("/cancel-paid", {
            INVOICE_ID: item.INVOICE_ID,
            TRANSACTION_ID: item.TRANSACTION_ID
          })
            .then((response) => {
              this.$swal("ยกเลิกการชำระเงิน", "สำเร็จ", "success");
              this.dialog = false
              this.list_invoices()

            })
            .catch((err) => {
              this.$swal("เกิดข้อผิดพลาด", "ลองใหม่อีกครั้ง", "error");
            });
        }
      });
    }
  },


};
</script>
